/**
 * Testi italiani delle pagine di lavoro trasversali (ADR 0032): Task di tutti i set,
 * Calendario delle scadenze, consumo per progetto.
 */

/** Testi delle pagine di lavoro. */
export const work = {
  /** Task di tutti i set. */
  allTasks: {
    /** Voce del menu. */
    nav: 'Tutti i task',
    /** Titolo. */
    title: 'Task di tutti i set',
    /** Che cosa mostra. */
    description: 'Le proposte da approvare e i task dei set in cui lavori.',
    /** Proposte. */
    proposalsTitle: 'Proposte da approvare',
    /** Conteggio delle proposte. */
    proposalsCount_one: '{{count}} proposta',
    /** Conteggio delle proposte. */
    proposalsCount_other: '{{count}} proposte',
    /** Altre proposte oltre le mostrate. */
    proposalsMore: 'Ne vedi {{shown}} su {{total}}: le altre sono nella sezione Task di ciascun set.',
    /** Nessuna proposta. */
    noProposals: 'Nessuna proposta da approvare.',
    /** Elenco. */
    listTitle: 'Task',
    /** Nessun task. */
    empty: 'Nessun task con questi filtri.',
    /** Lettura non riuscita. */
    loadFailed: 'Task non caricati. Riprova.',
    /** Filtri. */
    filters: {
      /** Nome del gruppo. */
      label: 'Filtri dei task',
      /** Set. */
      set: 'Set',
      /** Tutti i set. */
      allSets: 'Tutti i set',
      /** Tipo. */
      kind: 'Tipo',
      /** Priorità. */
      priority: 'Priorità',
      /** Stato. */
      status: 'Stato',
      /** Gruppo «aperti». */
      open: 'Aperti',
      /** Tutti gli stati. */
      allStatuses: 'Tutti gli stati',
      /** Solo i miei. */
      mine: 'Assegnati a me',
      /** Ricerca. */
      search: 'Cerca nel titolo',
      /** Ordine. */
      sort: 'Ordine',
      /** Toglie i filtri. */
      clear: 'Togli i filtri',
    },
    /** Ordini. */
    sorts: {
      /** Cambiati di recente. */
      updated: 'Cambiati di recente',
      /** Scadenza. */
      due: 'Scadenza',
      /** Priorità. */
      priority: 'Priorità',
      /** Creati di recente. */
      created: 'Creati di recente',
    },
    /** Colonne. */
    columns: {
      /** Chiave e titolo. */
      task: 'Task',
      /** Set e progetto. */
      where: 'Set e progetto',
      /** Stato. */
      status: 'Stato',
      /** Priorità. */
      priority: 'Priorità',
      /** Assegnatario. */
      assignee: 'Assegnato a',
      /** Scadenza. */
      due: 'Scadenza',
    },
  },

  /** Calendario delle scadenze. */
  calendar: {
    /** Voce del menu. */
    nav: 'Calendario',
    /** Titolo. */
    title: 'Calendario delle scadenze',
    /** Che cosa mostra. */
    description: 'I task con una scadenza, in tutti i set in cui lavori.',
    /** Vista. */
    view: 'Vista',
    /** Viste. */
    views: {
      /** Mese. */
      month: 'Mese',
      /** Settimana. */
      week: 'Settimana',
      /** Elenco per giorno. */
      agenda: 'Agenda',
    },
    /** Oggi. */
    today: 'Oggi',
    /** Precedente. */
    previous: 'Periodo precedente',
    /** Successivo. */
    next: 'Periodo successivo',
    /** Intestazione della settimana. */
    weekOf: 'Settimana dal {{from}} al {{to}}',
    /** Nessuna scadenza nel periodo. */
    empty: 'Nessuna scadenza in questo periodo.',
    /** Troppi task. */
    truncated: 'Ci sono più di 500 scadenze nel periodo: ne vedi le prime 500.',
    /** Lettura non riuscita. */
    loadFailed: 'Scadenze non caricate. Riprova.',
    /** Legenda delle priorità. */
    legend: 'Colori per priorità',
    /** Giorno con scadenze, nome accessibile. */
    dayLabel_one: '{{date}}, {{count}} scadenza',
    /** Giorno con scadenze, nome accessibile. */
    dayLabel_other: '{{date}}, {{count}} scadenze',
    /** Altre scadenze nella cella. */
    more: 'altre {{count}}',
    /** Un task, nome accessibile. */
    taskLabel: '{{key}} {{title}}, priorità {{priority}}, set {{set}}',
  },

  /** Consumo per progetto. */
  projectUsage: {
    /** Titolo. */
    title: 'Consumo per progetto',
    /** Che cosa mostra. */
    description: 'Token dei messaggi del set nel mese, progetto per progetto.',
    /** Mese. */
    month: 'Mese',
    /** Voce senza progetto. */
    allProjects: 'Tutti i progetti',
    /** Progetto tolto dal set. */
    removedProject: 'Progetto tolto dal set',
    /** Colonne. */
    columns: {
      /** Progetto. */
      project: 'Progetto',
      /** Token. */
      tokens: 'Token',
      /** Messaggi. */
      requests: 'Messaggi',
      /** Quota del totale. */
      share: 'Quota',
    },
    /** Totale. */
    total: 'Totale del mese: {{tokens}} token',
    /** Nessun consumo. */
    empty: 'Nessun consumo in questo mese.',
    /** Lettura non riuscita. */
    loadFailed: 'Consumo per progetto non caricato. Riprova.',
    /** Nota. */
    note: 'Contano i messaggi con qualunque credenziale, come il consumo per giorno.',
    /** Grafico per giorno del set scelto. */
    byDayTitle: 'Per progetto, giorno per giorno',
  },
};

/** Forma dei testi delle pagine di lavoro, usata per tipare le altre lingue. */
export type Work = typeof work;
